var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"dismissible":_vm.dismissible,"type":_vm.kind,"border":"left","outlined":"","prominent":"","text":""}},[_c('v-row',{attrs:{"align":"center"}},[_c('v-col',{staticClass:"grow text-body-1"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.message)}})]),_c('v-col',{staticClass:"shrink"},[_vm._t("action")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }